import { render, staticRenderFns } from "./PropertyManagementAgreement.vue?vue&type=template&id=edbc695e&"
import script from "./PropertyManagementAgreement.vue?vue&type=script&lang=js&"
export * from "./PropertyManagementAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports